<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
        Agregar puesto de trabajo
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="ngbActiveModal.close()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div class="form-group" *ngIf="jobs.length > 0">
        <ul class="list-group">
            <li class="list-group-item cursor-pointer" *ngFor="let job of jobs" (click)="selectJob(job)">
                {{job.name}}
            </li>
        </ul>
    </div>
</div>
<div class="modal-footer">
    <div class="btn-group w-100" role="group">
        <button type="button" class="btn btn-secondary" (click)="ngbActiveModal.close()" [disabled]="isSaving">
            <span>Cancelar</span>
        </button>
        <button type="button" class="btn btn-success" [disabled]="isSaving" (click)="save()">
            <span>Guardar</span>
            <div class="spinner-border" role="status" *ngIf="isSaving">
                <span class="visually-hidden"></span>
            </div>
        </button>
    </div>
</div>